module.exports = __webpack_public_path__ + "static/media/mmm-icon-street.fa7692e9.svg";